import { enqueueSnackbar, DownloadFile } from 'actions';
import {
	hcGetCrqsToCreateRequest, hcGetCrqsToCreateSuccess, hcGetCrqsToCreateFailure,
	hcGetCrqsOnQueueWithErrorRequest, hcGetCrqsOnQueueWithErrorSuccess, hcGetCrqsOnQueueWithErrorFailure,
	hcCrqsToCreateRequest, hcCrqsToCreateSuccess, hcCrqsToCreateFailure,
	hcCrqsOnQueueWithErrorRequest, hcCrqsOnQueueWithErrorSuccess, hcCrqsOnQueueWithErrorFailure,
	hcGetCrqsToCloseRequest, hcGetCrqsToCloseSuccess, hcGetCrqsToCloseFailure,
	hcGetCrqsToCancelRequest, hcGetCrqsToCancelSuccess, hcGetCrqsToCancelFailure,
	hcGetCrqsToApproveRequest, hcGetCrqsToApproveSuccess, hcGetCrqsToApproveFailure,
	hcCrqsToChangeActionRequest, hcCrqsToChangeActionSuccess, hcCrqsToChangeActionFailure,
	hcGetCrqsWithConflictsRequest, hcGetCrqsWithConflictsSuccess, hcGetCrqsWithConflictsFailure,
	hcGetCrqsToAddActivityRequest, hcGetCrqsToAddActivitySuccess, hcGetCrqsToAddActivityFailure,
	hcCrqsWithConflictsRequest, hcCrqsWithConflictsSuccess, hcCrqsWithConflictsFailure,
	hcCrqsToAddActivityRequest, hcCrqsToAddActivitySuccess, hcCrqsToAddActivityFailure,
	hcGetBotSummaryRequest, hcGetBotSummarySuccess, hcGetBotSummaryFailure,
	hcDownloadTemplateRequest, hcDownloadTemplateSuccess, hcDownloadTemplateFailure,
	hcDownloadChangesTemplateRequest, hcDownloadChangesTemplateSuccess, hcDownloadChangesTemplateFailure,
	hcDownloadAddActivityTemplateRequest, hcDownloadAddActivityTemplateSuccess, hcDownloadAddActivityTemplateFailure,
	hcGetStatisticsRequest, hcGetStatisticsSuccess, hcGetStatisticsFailure,
	hcExportCrqsCreationsRequest, hcExportCrqsCreationsSuccess, hcExportCrqsCreationsFailure,
	hcExportCrqsChangesRequest, hcExportCrqsChangesSuccess, hcExportCrqsChangesFailure,
	hcExportCrqsOtherRequest, hcExportCrqsOtherSuccess, hcExportCrqsOtherFailure,
	hcExportCrqsStatisticsRequest, hcExportCrqsStatisticsSuccess, hcExportCrqsStatisticsFailure,
} from '../actions/helixCrqsActions';
import {
	HelixCreationsGetCrqsToCreateRequest,
	HelixCreationsGetCrqsOnQueueWithErrorRequest,
	HelixCrqsToCreateRequest,
	HelixCrqsOnQueueWithErrorRequest,
	HelixChangesGetCrqsToCloseRequest,
	HelixChangesGetCrqsToCancelRequest,
	HelixChangesGetCrqsToApproveRequest,
	HelixCrqsToChangeActionRequest,
	HelixChangesGetCrqsWithConflictsRequest,
	HelixChangesGetCrqsToAddActivityRequest,
	HelixCrqsWithConflictsRequest,
	HelixCrqsToAddActivityRequest,
	HelixGetBotSummaryRequest,
	HelixCreationsDownloadTemplateRequest,
	HelixChangesDownloadTemplateRequest,
	HelixAddActivityDownloadTemplateRequest,
	HelixGetStatisticsRequest,
	HelixExportCrqsCreationsRequest,
	HelixExportCrqsChangesRequest,
	HelixExportCrqsOtherRequest,
	HelixExportCrqsStatisticsRequest,
} from '../requests/helixCrqsRequests';

// ─── CREATIONS — initial load ─────────────────────────────────────────────────

export const hcGetCrqsToCreate = (history = false) => async (dispatch) => {
	dispatch(hcGetCrqsToCreateRequest());
	await HelixCreationsGetCrqsToCreateRequest(history).then((response) => {
		dispatch(hcGetCrqsToCreateSuccess(response.data ?? []));
	}).catch((error) => {
		dispatch(hcGetCrqsToCreateFailure(error?.message));
	});
};

export const hcGetCrqsOnQueueWithError = (history = false) => async (dispatch) => {
	dispatch(hcGetCrqsOnQueueWithErrorRequest());
	await HelixCreationsGetCrqsOnQueueWithErrorRequest(history).then((response) => {
		dispatch(hcGetCrqsOnQueueWithErrorSuccess(response.data ?? []));
	}).catch((error) => {
		dispatch(hcGetCrqsOnQueueWithErrorFailure(error?.message));
	});
};

// ─── CREATIONS — silent poll ──────────────────────────────────────────────────

export const hcPollCrqsToCreate = (history = false) => async (dispatch) => {
	await HelixCreationsGetCrqsToCreateRequest(history).then((response) => {
		dispatch(hcGetCrqsToCreateSuccess(response.data ?? []));
	}).catch(() => {});
};

export const hcPollCrqsOnQueueWithError = (history = false) => async (dispatch) => {
	await HelixCreationsGetCrqsOnQueueWithErrorRequest(history).then((response) => {
		dispatch(hcGetCrqsOnQueueWithErrorSuccess(response.data ?? []));
	}).catch(() => {});
};

// ─── CREATIONS — actions ──────────────────────────────────────────────────────

export const hcCrqsToCreateAction = (userId, action, idList, crqChangeIds, bot = 0) => async (dispatch) => {
	dispatch(hcCrqsToCreateRequest());
	await HelixCrqsToCreateRequest(userId, action, idList, crqChangeIds, bot).then((response) => {
		dispatch(hcCrqsToCreateSuccess(response.data));
	}).catch((error) => {
		dispatch(hcCrqsToCreateFailure(error?.message));
	});
};

export const hcCrqsOnQueueWithErrorAction = (userId, action, idList, crqChangeIds, bot = 0) => async (dispatch) => {
	dispatch(hcCrqsOnQueueWithErrorRequest());
	await HelixCrqsOnQueueWithErrorRequest(userId, action, idList, crqChangeIds, bot).then((response) => {
		dispatch(hcCrqsOnQueueWithErrorSuccess(response.data));
	}).catch((error) => {
		dispatch(hcCrqsOnQueueWithErrorFailure(error?.message));
	});
};

// ─── CHANGES — initial load ───────────────────────────────────────────────────

export const hcGetCrqsToClose = (history = false) => async (dispatch) => {
	dispatch(hcGetCrqsToCloseRequest());
	await HelixChangesGetCrqsToCloseRequest(history).then((response) => {
		dispatch(hcGetCrqsToCloseSuccess(response.data ?? []));
	}).catch((error) => {
		dispatch(hcGetCrqsToCloseFailure(error?.message));
	});
};

export const hcGetCrqsToCancel = (history = false) => async (dispatch) => {
	dispatch(hcGetCrqsToCancelRequest());
	await HelixChangesGetCrqsToCancelRequest(history).then((response) => {
		dispatch(hcGetCrqsToCancelSuccess(response.data ?? []));
	}).catch((error) => {
		dispatch(hcGetCrqsToCancelFailure(error?.message));
	});
};

export const hcGetCrqsToApprove = (history = false) => async (dispatch) => {
	dispatch(hcGetCrqsToApproveRequest());
	await HelixChangesGetCrqsToApproveRequest(history).then((response) => {
		dispatch(hcGetCrqsToApproveSuccess(response.data ?? []));
	}).catch((error) => {
		dispatch(hcGetCrqsToApproveFailure(error?.message));
	});
};

// ─── CHANGES — silent poll ────────────────────────────────────────────────────

export const hcPollCrqsToClose = (history = false) => async (dispatch) => {
	await HelixChangesGetCrqsToCloseRequest(history).then((response) => {
		dispatch(hcGetCrqsToCloseSuccess(response.data ?? []));
	}).catch(() => {});
};

export const hcPollCrqsToCancel = (history = false) => async (dispatch) => {
	await HelixChangesGetCrqsToCancelRequest(history).then((response) => {
		dispatch(hcGetCrqsToCancelSuccess(response.data ?? []));
	}).catch(() => {});
};

export const hcPollCrqsToApprove = (history = false) => async (dispatch) => {
	await HelixChangesGetCrqsToApproveRequest(history).then((response) => {
		dispatch(hcGetCrqsToApproveSuccess(response.data ?? []));
	}).catch(() => {});
};

// ─── CHANGES — actions ────────────────────────────────────────────────────────

export const hcCrqsToChangeAction = (userId, action, idList, crqChangeIds, bot = 0) => async (dispatch) => {
	dispatch(hcCrqsToChangeActionRequest());
	await HelixCrqsToChangeActionRequest(userId, action, idList, crqChangeIds, bot).then((response) => {
		dispatch(hcCrqsToChangeActionSuccess(response.data));
	}).catch((error) => {
		dispatch(hcCrqsToChangeActionFailure(error?.message));
	});
};

// ─── OTHER — initial load ─────────────────────────────────────────────────────

export const hcGetCrqsWithConflicts = (history = false) => async (dispatch) => {
	dispatch(hcGetCrqsWithConflictsRequest());
	await HelixChangesGetCrqsWithConflictsRequest(history).then((response) => {
		dispatch(hcGetCrqsWithConflictsSuccess(response.data ?? []));
	}).catch((error) => {
		dispatch(hcGetCrqsWithConflictsFailure(error?.message));
	});
};

export const hcGetCrqsToAddActivity = (history = false) => async (dispatch) => {
	dispatch(hcGetCrqsToAddActivityRequest());
	await HelixChangesGetCrqsToAddActivityRequest(history).then((response) => {
		dispatch(hcGetCrqsToAddActivitySuccess(response.data ?? []));
	}).catch((error) => {
		dispatch(hcGetCrqsToAddActivityFailure(error?.message));
	});
};

// ─── OTHER — silent poll ──────────────────────────────────────────────────────

export const hcPollCrqsWithConflicts = (history = false) => async (dispatch) => {
	await HelixChangesGetCrqsWithConflictsRequest(history).then((response) => {
		dispatch(hcGetCrqsWithConflictsSuccess(response.data ?? []));
	}).catch(() => {});
};

export const hcPollCrqsToAddActivity = (history = false) => async (dispatch) => {
	await HelixChangesGetCrqsToAddActivityRequest(history).then((response) => {
		dispatch(hcGetCrqsToAddActivitySuccess(response.data ?? []));
	}).catch(() => {});
};

// ─── OTHER — actions ──────────────────────────────────────────────────────────

export const hcCrqsWithConflictsAction = (userId, action, idList, crqChangeIds, bot = 0) => async (dispatch) => {
	dispatch(hcCrqsWithConflictsRequest());
	await HelixCrqsWithConflictsRequest(userId, action, idList, crqChangeIds, bot).then((response) => {
		dispatch(hcCrqsWithConflictsSuccess(response.data));
	}).catch((error) => {
		dispatch(hcCrqsWithConflictsFailure(error?.message));
	});
};

export const hcCrqsToAddActivityAction = (userId, action, idList, crqChangeIds, bot = 0) => async (dispatch) => {
	dispatch(hcCrqsToAddActivityRequest());
	await HelixCrqsToAddActivityRequest(userId, action, idList, crqChangeIds, bot).then((response) => {
		dispatch(hcCrqsToAddActivitySuccess(response.data));
	}).catch((error) => {
		dispatch(hcCrqsToAddActivityFailure(error?.message));
	});
};

// ─── UPLOAD — Bot Summary ─────────────────────────────────────────────────────

export const hcGetBotSummary = () => async (dispatch) => {
	dispatch(hcGetBotSummaryRequest());
	await HelixGetBotSummaryRequest().then((response) => {
		dispatch(hcGetBotSummarySuccess(response.data ?? []));
	}).catch((error) => {
		dispatch(hcGetBotSummaryFailure(error?.message));
	});
};

export const hcPollBotSummary = () => async (dispatch) => {
	await HelixGetBotSummaryRequest().then((response) => {
		dispatch(hcGetBotSummarySuccess(response.data ?? []));
	}).catch(() => {});
};

// ─── UPLOAD — Download Templates ─────────────────────────────────────────────

export const hcDownloadCreationsTemplate = () => async (dispatch) => {
	dispatch(hcDownloadTemplateRequest());
	await HelixCreationsDownloadTemplateRequest().then((response) => {
		dispatch(DownloadFile(response.data));
		dispatch(hcDownloadTemplateSuccess());
		dispatch(enqueueSnackbar({ message: 'Template downloaded successfully.', options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(hcDownloadTemplateFailure(error?.message));
		if (error) dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
	});
};

export const hcDownloadChangesTemplate = () => async (dispatch) => {
	dispatch(hcDownloadChangesTemplateRequest());
	await HelixChangesDownloadTemplateRequest().then((response) => {
		dispatch(DownloadFile(response.data));
		dispatch(hcDownloadChangesTemplateSuccess());
		dispatch(enqueueSnackbar({ message: 'Template downloaded successfully.', options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(hcDownloadChangesTemplateFailure(error?.message));
		if (error) dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
	});
};

export const hcDownloadAddActivityTemplate = () => async (dispatch) => {
	dispatch(hcDownloadAddActivityTemplateRequest());
	await HelixAddActivityDownloadTemplateRequest().then((response) => {
		dispatch(DownloadFile(response.data));
		dispatch(hcDownloadAddActivityTemplateSuccess());
		dispatch(enqueueSnackbar({ message: 'Template downloaded successfully.', options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(hcDownloadAddActivityTemplateFailure(error?.message));
		if (error) dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
	});
};

// ─── STATISTICS ───────────────────────────────────────────────────────────────

export const hcGetStatistics = () => async (dispatch) => {
	dispatch(hcGetStatisticsRequest());
	await HelixGetStatisticsRequest().then((response) => {
		dispatch(hcGetStatisticsSuccess(response.data ?? []));
	}).catch((error) => {
		dispatch(hcGetStatisticsFailure(error?.message));
	});
};

export const hcPollStatistics = () => async (dispatch) => {
	await HelixGetStatisticsRequest().then((response) => {
		dispatch(hcGetStatisticsSuccess(response.data ?? []));
	}).catch(() => {});
};

// ─── CREATIONS — Export ───────────────────────────────────────────────────────

export const hcExportCrqsCreations = () => async (dispatch) => {
	dispatch(hcExportCrqsCreationsRequest());
	await HelixExportCrqsCreationsRequest().then((response) => {
		dispatch(DownloadFile(response.data));
		dispatch(hcExportCrqsCreationsSuccess());
		dispatch(enqueueSnackbar({ message: 'File exported successfully.', options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(hcExportCrqsCreationsFailure(error?.message));
		if (error) dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
	});
};

// ─── CHANGES — Export ─────────────────────────────────────────────────────────

export const hcExportCrqsChanges = () => async (dispatch) => {
	dispatch(hcExportCrqsChangesRequest());
	await HelixExportCrqsChangesRequest().then((response) => {
		dispatch(DownloadFile(response.data));
		dispatch(hcExportCrqsChangesSuccess());
		dispatch(enqueueSnackbar({ message: 'File exported successfully.', options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(hcExportCrqsChangesFailure(error?.message));
		if (error) dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
	});
};

// ─── OTHER — Export ───────────────────────────────────────────────────────────

export const hcExportCrqsOther = () => async (dispatch) => {
	dispatch(hcExportCrqsOtherRequest());
	await HelixExportCrqsOtherRequest().then((response) => {
		dispatch(DownloadFile(response.data));
		dispatch(hcExportCrqsOtherSuccess());
		dispatch(enqueueSnackbar({ message: 'File exported successfully.', options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(hcExportCrqsOtherFailure(error?.message));
		if (error) dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
	});
};

// ─── STATISTICS — Export ──────────────────────────────────────────────────────

export const hcExportCrqsStatistics = () => async (dispatch) => {
	dispatch(hcExportCrqsStatisticsRequest());
	await HelixExportCrqsStatisticsRequest().then((response) => {
		dispatch(DownloadFile(response.data));
		dispatch(hcExportCrqsStatisticsSuccess());
		dispatch(enqueueSnackbar({ message: 'File exported successfully.', options: { variant: 'success' } }));
	}).catch((error) => {
		dispatch(hcExportCrqsStatisticsFailure(error?.message));
		if (error) dispatch(enqueueSnackbar({ message: error.message, options: { variant: 'error' } }));
	});
};